
<template>
  <div style="">
    <a-card :bordered="false" style="margin-top:10px;box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
      <a-tabs defaultActiveKey="1" @change="callback" >
        
        <a-tab-pane tab="   学员  " key="1">
          <StudentManage ref="studentManage"></StudentManage>
        </a-tab-pane>
        <a-tab-pane tab="黑名单" key="2" forceRender>
          <BlackStudentList ref="blackStudentList"></BlackStudentList>
        </a-tab-pane>
      </a-tabs>
    </a-card>
    
  </div>
</template>

<script>
// import { JeecgListMixin } from '@/mixins/JeecgListMixin'

import StudentManage from '../../components/studentManagement/studentList/StudentManage'
import BlackStudentList from '../../components/studentManagement/studentList/BlackStudentList'


export default {
  name: 'StudentList',
  mixins: [],
  components: {StudentManage,BlackStudentList},

  data() {
    return {
      description: '学员管理页面',
      
      // 请求参数
      
    }
  },
  computed: {
    // importExcelUrl: function() {
      // return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    // }
  },

  methods: {
    callback(k){
      if(k==1){
         this.$refs.studentManage.refreshData(); 
      }else{
        this.$refs.blackStudentList.refreshData();
      }
      
    //   this.$forceUpdate();
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
<style lang="scss" scoped >

</style>